
import React, { } from "react";
import { Button } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import { faBars } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { documentLabelPanelAction } from "../../../context/actions/documentLabelPanelAction";
import "../index.scss";

const SiteUse = () => {

    const documentLabelPanelOnState = useSelector(state => state.documentLabelPanelReducer.documentLabelPanelOn);
    const dispatch = useDispatch();

    const documentLabelPanelHandler = () => {
        dispatch(documentLabelPanelAction(!documentLabelPanelOnState))
    }
    const overlayHandler = () => {
        dispatch(documentLabelPanelAction(false))
    }
    return (

        <div className="site-use-page">
            <section className="content-section">
                <h2>PLEASE READ THESE TERMS AND CONDITIONS VERY CAREFULLY</h2>
                <p>By accessing or otherwise using any TRAINED Website or mobile application (each, a "Site") you agree to be bound by these terms and conditions of use and any other applicable end-user agreements.
                </p>
            </section>
            <section className="content-section">
                <h2>Changes to the Terms and Conditions </h2>
                <p>TRAINED may change these terms and conditions of use at any time, without prior notice. If you access or use a Site after TRAINED posts a change, you accept that change. If you do not accept the change, do not access or use the Site. You should check these terms and conditions of use periodically.
                </p>
            </section>
            <section className="content-section">
                <h2>Access and Use of a Site </h2>
                <p>
                    TRAINED grants you a limited license to access and use the applicable Site, including to display, copy, distribute and download its content, only for your personal, non-commercial use and provided that you do not modify the Site, its content, or any copyright or other proprietary notices. This license terminates automatically if you breach any of these terms and conditions of use. Upon termination, you must immediately destroy all copies in your possession.
                </p>
                <p>
                    Unauthorized use of a Site or any content may violate copyright laws, trademark laws, the laws of privacy and publicity, and communications regulations and statutes.
                </p>
            </section>
            <section className="content-section">
                <h2>Restrictions on Use of a Site</h2>
                <p>
                    Except as expressly authorized above, you may not copy, modify, distribute, download, display, transfer, post or transmit the Site or its content in any form without TRAINED's prior written permission.
                </p>
                <p>
                    The following activities are also expressly prohibited without TRAINED's prior written permission: any non-personal or commercial use; use of any robot, spider, other automatic device, or manual process to monitor or copy a Site or any of its content; "mirroring" a Site or any content on any other server; and any action that imposes an unreasonable or disproportionately large load on a Site or otherwise interferes with its functioning.
                </p>
            </section>
            <section className="content-section">
                <h2>Posting and Transmitting to a Site</h2>
                <p className="bg-style-1">
                    Except for information that is subject to the TRAINED Privacy Policy, TRAINED will treat information you post or transmit to a Site as confidential or proprietary. By sending information to TRAINED through a Site (by transmitting, posting, or otherwise), you agree that TRAINED may use that information in any way, for any purpose, including TRAINED's own commercial purposes, subject only to the TRAINED Privacy Policy.
                </p>
                <p>
                    You may not post or transmit any threatening, defamatory, sexually graphic, inflammatory, profane or other inappropriate material. TRAINED reserves the right to edit or remove any transmission that, in its judgment, is not appropriate.
                </p>
            </section>
            <section className="content-section">
                <h2>Accuracy of Information and Disclaimer of Warranty</h2>
                <p>
                    TRAINED has made every effort to present the content each Site accurately, but additions, deletions and changes may occur. Content on a Site is provided "as is"; neither TRAINED nor its representatives make any representation or warranty with respect to the content.
                </p>
                <p>
                    TRAINED and its representatives specifically disclaim, to the fullest extent permitted by law, any and all warranties, express or implied, relating to a Site or its content, including but not limited to, implied warranties of merchantability, completeness, timeliness, correctness, noninfringement or fitness for any particular purpose.
                </p>
            </section>
            <section className="content-section">
                <h2>Limitation of Liability</h2>
                <p>
                    Under no circumstances will TRAINED or its affiliates have any liability with respect to any claims or damages (whether direct or indirect, special, incidental, consequential or punitive) as a result of your access or use of (or inability to access or use) a Site or its content, even if they have been advised of the possibility of such damages. You access and use each Site at your own risk.
                </p>
            </section>
            <section className="content-section">
                <h2>Links to a Site</h2>
                <p>
                    TRAINED grants you a limited, revocable, and nonexclusive right to create a hyperlink to the home page of each Site so long as the link does not portray TRAINED or its products or services in a false, misleading, derogatory, or offensive matter. You may not use the TRAINED logo, TRAINED trademark, or TRAINED's name or trademarks, or other proprietary graphic in the link without the prior written permission of TRAINED.
                </p>
            </section>
            <section className="content-section">
                <h2>Links to Third Party Websites</h2>
                <p>
                    TRAINED does not review or control third party Websites that link to or from each Site, is not responsible for their content, and does not represent that their content is accurate or appropriate. Your use of such third party site is on your own initiative and at your own risk and may be subject to the other sites' terms of use.
                </p>
            </section>
            <section className="content-section">
                <h2>Ownership</h2>
                <p>
                    The material provided on each Site is protected by law, including, but not limited to, United States copyright law and international treaties. The copyright in the content of each Site is owned by TRAINED or others. Except for the limited rights granted above, all other rights are reserved.
                </p>
                <p>
                    All trademarks are the property of their respective owners. Some images are courtesy of manufacturers.
                </p>
            </section>
            <section className="content-section">
                <h2>For Use in the United States</h2>
                <p>Each Site is controlled and operated by TRAINED from its offices within the United States. TRAINED does not represent that a Site is appropriate or available for use elsewhere; access to a Site from locations where its contents are illegal is not authorized. If you access a Site from outside the United States, you do so on your own initiative and at your own risk.
                </p>
            </section>
            <section className="content-section">
                <h2>Privacy</h2>
                <p>Please review the <a href="">TRAINED Privacy Policy</a>, which also governs your visit to this Website.
                </p>
            </section>
        </div>

    )
};
export default SiteUse;